// Heart-and-wing mark — from Jenn's own emoji language (🤍🪽: "a heart and
// wing"). Thin line-art to match the site's restrained style, not an emoji.
// Magenta-outlined with a transparent center by default.
export const HeartIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size * 1.45}
    height={size}
    viewBox="0 0 35 22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.1"
    strokeLinecap="round"
    className={`text-[var(--sm-gold)] ${className}`}
    aria-hidden
  >
    <path d="M12 20.5C12 20.5 1.5 13.8 1.5 6.9C1.5 3.6 4.1 1.5 7 1.5C9 1.5 10.8 2.6 12 4.5C13.2 2.6 15 1.5 17 1.5C19.9 1.5 22.5 3.6 22.5 6.9C22.5 13.8 12 20.5 12 20.5Z" />
    <path d="M22.3 5.2C25.5 3.2 29.6 2.4 33.4 3.1C31.6 4.6 29.4 5.6 27.1 6.1C29.3 6.3 31.4 7 33 8.3C30.3 9.1 27.2 9.1 24.4 8.4C26.1 9.4 27.4 10.8 28.1 12.4C25.6 12.1 23.3 11.1 21.5 9.6" />
  </svg>
);
